<script lang="ts">
	import { onMount } from "svelte";
	import { Router, Link, Route } from "svelte-navigator";
	import Home from "./routes/Home.svelte";
	import Galleries from "./routes/Galleries.svelte";
	import MonthlyImages from "./routes/MonthlyImages.svelte";
	import WeeklyImages from "./routes/WeeklyImages.svelte";
	import NavMobile from "./NavMobile.svelte";
	import Nav from "./Nav.svelte";
	import { Container } from "sveltestrap";

	export let url = "";
	let width;
</script>

<svelte:window bind:innerWidth={width} />

<main>
	<Router {url}>
		{#if width < 768}
			<NavMobile />
		{:else}
			<Nav />
		{/if}
		<Container fluid>
			<Route path="/"><Home /></Route>
			<Route path="/linnut/*"><Galleries gallery={"birds"} /></Route>
			<Route path="/galleriat/*"><Galleries gallery={"gallery"} /></Route>
			<Route path="/matkat/*"><Galleries gallery={"trip"} /></Route>
			<Route path="/viikonkuva"><WeeklyImages /></Route>
			<Route path="/kuukaudenkuva"><MonthlyImages /></Route>
		</Container>
	</Router>
</main>

<style>
	main {
		text-align: center;
		margin: 0 auto;
		margin-top: 50px;
	}

	:global(h1, h2, h3, a) {
		color: #f3f3f3 !important;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
